import { PROBABILITY_PAGE_TYPE } from 'components/probability/tooltip-handler';

export const WIN_PROBABILITY = 'win probability';
export const TOP_10_PROBABILITY = 'top 10';
export const MAKE_CUT_PROBABILITY = 'make cut';
export const WIN_PROBABILITY_VS_LEADERS = 'win probability vs leaders';

export const getFieldName = (type) => {
    switch (type) {
        case WIN_PROBABILITY:
        case WIN_PROBABILITY_VS_LEADERS:
            return 'winProbabilityRounds';
        case TOP_10_PROBABILITY:
            return 'top10Rounds';
        case MAKE_CUT_PROBABILITY:
            return 'makeCutRounds';
        default:
            return '';
    }
};

export const getTooltipLabel = (type) => {
    switch (type) {
        case WIN_PROBABILITY:
        case WIN_PROBABILITY_VS_LEADERS:
            return 'win probability';
        case TOP_10_PROBABILITY:
            return 'top 10 probability';
        case MAKE_CUT_PROBABILITY:
            return 'make cut probability';
        default:
            return '';
    }
};

export const getSwiperLocation = (pageType) => {
    switch (pageType) {
        case PROBABILITY_PAGE_TYPE.LEADERBOARD: {
            return 'Leader Board';
        }
        case PROBABILITY_PAGE_TYPE.LIVE_VIDEO: {
            return 'Live Video Drawer';
        }
        default: {
            return pageType;
        }
    }
};
